// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep {
  /*buttons*/
  /* ionic components */
  /* input-form */
  /* end */
}
:host ::ng-deep ion-app {
  margin: auto;
}
:host ::ng-deep .nh1 span, :host ::ng-deep .nh1 ion-icon, :host ::ng-deep .nh1 ion-card-title, :host ::ng-deep .nh1 div, :host ::ng-deep .nh1 ion-label,
:host ::ng-deep .nh1 h1, :host ::ng-deep .nh1 h2, :host ::ng-deep .nh1 h3, :host ::ng-deep .nh1 h4, :host ::ng-deep .nh1 p, :host ::ng-deep .nh1 ion-button, :host ::ng-deep .nh1 div, :host ::ng-deep .nh1 ion-col, :host ::ng-deep .nh1 ion-card-subtitle {
  font-size: 3rem !important;
}
:host ::ng-deep .nh2 span, :host ::ng-deep .nh2 ion-icon, :host ::ng-deep .nh2 ion-card-title, :host ::ng-deep .nh2 div, :host ::ng-deep .nh2 ion-label,
:host ::ng-deep .nh2 h1, :host ::ng-deep .nh2 h2, :host ::ng-deep .nh2 h3, :host ::ng-deep .nh2 h4, :host ::ng-deep .nh2 p, :host ::ng-deep .nh2 ion-button, :host ::ng-deep .nh2 div, :host ::ng-deep .nh2 ion-col, :host ::ng-deep .nh2 ion-card-subtitle {
  font-size: 2.3rem !important;
}
:host ::ng-deep .nh3 span, :host ::ng-deep .nh3 ion-icon, :host ::ng-deep .nh3 ion-card-title, :host ::ng-deep .nh3 div, :host ::ng-deep .nh3 ion-label,
:host ::ng-deep .nh3 h1, :host ::ng-deep .nh3 h2, :host ::ng-deep .nh3 h3, :host ::ng-deep .nh3 h4, :host ::ng-deep .nh3 p, :host ::ng-deep .nh3 ion-button, :host ::ng-deep .nh3 div, :host ::ng-deep .nh3 ion-col, :host ::ng-deep .nh3 ion-card-subtitle {
  font-size: 1.5rem !important;
}
:host ::ng-deep .nh4 span, :host ::ng-deep .nh4 ion-icon, :host ::ng-deep .nh4 ion-card-title, :host ::ng-deep .nh4 div, :host ::ng-deep .nh4 ion-label,
:host ::ng-deep .nh4 h1, :host ::ng-deep .nh4 h2, :host ::ng-deep .nh4 h3, :host ::ng-deep .nh4 h4, :host ::ng-deep .nh4 p, :host ::ng-deep .nh4 ion-button, :host ::ng-deep .nh4 div, :host ::ng-deep .nh4 ion-col, :host ::ng-deep .nh4 ion-card-subtitle {
  font-size: 1.5rem !important;
}
:host ::ng-deep .button-outline {
  --border-width: 1px !important;
}
:host ::ng-deep ion-badge .h1 {
  font-size: 1.5rem !important;
}
:host ::ng-deep .showScroll {
  overflow: scroll;
  overscroll-behavior: contain;
}
:host ::ng-deep .abs {
  position: absolute;
  display: none;
}
:host ::ng-deep .abs .abs-close-btn {
  background: #000;
  text-align: center;
  padding-top: 3px;
  margin-top: -3px;
  color: #fff;
  border-radius: 5px;
}
@media screen and (min-width: 1400px) {
  :host ::ng-deep .abs {
    display: inherit;
  }
}
:host ::ng-deep .negishotIcon {
  background: white;
  padding: 3px;
  text-align: left;
}
:host ::ng-deep .app-loading-page-sub {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  max-width: 1000px;
  margin: 0 auto;
  background-position: center;
  background-repeat: no-repeat;
}
:host ::ng-deep .app-loading-page {
  height: 100%;
  width: 100%;
  display: initial;
  position: absolute;
  z-index: 200;
}
:host ::ng-deep .topheader-fade {
  transition: margin-top 0.3s ease-in-out;
}
:host ::ng-deep .topheader-fade-off {
  margin-top: 0px;
}
:host ::ng-deep .topheader-fade-on {
  margin-top: -100px;
}
:host ::ng-deep .app-loading-page.bis-loading {
  background-size: cover;
  background-position: center;
}
:host ::ng-deep .no-padding {
  padding: 0;
}
:host ::ng-deep .no-padding-x {
  padding-right: 0;
  padding-left: 0;
}
:host ::ng-deep .no-margin-x {
  margin-right: 0;
  margin-left: 0;
}
:host ::ng-deep .no-margin-top {
  margin-top: 0;
}
:host ::ng-deep .padding-x {
  padding-right: 5px;
  padding-left: 5px;
}
:host ::ng-deep .top-row {
  padding: 10px;
  text-align: center;
}
:host ::ng-deep .button-a, :host ::ng-deep .button-b {
  border-radius: 8px;
  border: 0;
  text-align: center;
}
:host ::ng-deep .button-a ion-spinner, :host ::ng-deep .button-b ion-spinner {
  width: 20px;
}
:host ::ng-deep ion-buttons ion-button.button-a, :host ::ng-deep ion-buttons ion-button.button-b {
  --border-radius: 5px;
  border-radius: 5px;
}
:host ::ng-deep .button-a.success {
  --background: #7bb078;
  background: #7bb078;
  color: #fff;
}
:host ::ng-deep .button-a.warning {
  --background: #f44336;
  background: #f44336;
  color: #fff;
}
:host ::ng-deep .button-a ion-icon, :host ::ng-deep .button-b ion-icon {
  font-size: 17px;
  vertical-align: middle;
}
:host ::ng-deep .button-a.big-icon, :host ::ng-deep .button-b.big-icon {
  --padding-start: 0;
  --padding-end: 0;
}
:host ::ng-deep .button-a.big-icon ion-icon, :host ::ng-deep .button-b.big-icon ion-icon {
  font-size: 30px;
}
:host ::ng-deep .button-a.big, :host ::ng-deep .button-b.big, :host ::ng-deep .button-a.button-big, :host ::ng-deep .button-a.button-big {
  font-weight: 700;
  width: 60%;
  height: 60px;
  font-size: 26px;
  margin: 15px auto;
}
:host ::ng-deep .button-a.trash, :host ::ng-deep .button-b.trash {
  --padding-start: 5px;
  --padding-end: 5px;
}
:host ::ng-deep .button-a.medium, :host ::ng-deep .button-b.medium {
  font-weight: 700;
  width: 40%;
  height: 50px;
  font-size: 20px;
  margin: 15px auto;
}
:host ::ng-deep .button-a.small, :host ::ng-deep .button-b.small {
  height: 30px;
}
:host ::ng-deep .title-row {
  width: 90%;
  text-align: center;
  padding: 5px;
  margin: 5px auto;
  border-radius: 5px;
}
:host ::ng-deep .title-row .title-icon {
  font-size: 20px;
}
:host ::ng-deep .section-box .title-box {
  position: absolute;
  bottom: 0px;
  z-index: 7;
  background: #000;
  width: 100%;
  opacity: 0.7;
  line-height: 1;
  padding: 3px;
  height: 30px;
  font-weight: 700;
  text-align: center;
  color: var(--button-b-text);
  box-shadow: 0px 5px 22px 3px #979797;
  display: table;
}
:host ::ng-deep .section-box .title-box span {
  vertical-align: middle;
  display: table-cell;
  width: 100%;
}
:host ::ng-deep .section-box .title-box p {
  display: table-row-group;
}
:host ::ng-deep .ticket-dividerMark {
  background: var(--button-a-background);
  padding: 3px;
}
:host ::ng-deep .vert-center, :host ::ng-deep .vert-bottom {
  display: table;
  min-height: 56px;
}
:host ::ng-deep .vert-center .vert-box {
  vertical-align: middle;
  display: table-cell;
}
:host ::ng-deep .vert-bottom .vert-box {
  vertical-align: bottom;
  display: table-cell;
  width: 100%;
}
:host ::ng-deep .box-shadow {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}
:host ::ng-deep .background-contain {
  background-size: contain;
}
:host ::ng-deep .padding-5 {
  padding: 5px;
}
:host ::ng-deep .margin-top {
  margin-top: 10px;
}
:host ::ng-deep .no-margin-x {
  margin-right: 0;
  margin-left: 0;
}
:host ::ng-deep .relative {
  position: relative;
}
:host ::ng-deep .position-fixed {
  position: fixed;
}
:host ::ng-deep .relative .name-box {
  position: absolute;
  color: #fff;
  z-index: 25;
  bottom: 0;
  width: 100%;
  text-shadow: 1px 1px 3px #000;
  padding: 0 35px;
  /* font-size: 29px; */
  font-size: 20px;
  padding-bottom: 10px;
  background-color: rgba(0, 0, 0, 0.4);
}
:host ::ng-deep .on-image-title {
  position: absolute;
  color: #fff;
  z-index: 25;
  bottom: 0;
  width: 100%;
  text-shadow: 1px 1px 3px #000;
  /* padding: 0 35px; */
  text-align: center;
  font-size: 15px;
  /* padding-bottom: 10px; */
  background-color: rgba(0, 0, 0, 0.4);
}
:host ::ng-deep .absolute {
  position: absolute;
}
:host ::ng-deep .pre-line {
  white-space: pre-line;
}
:host ::ng-deep .inline-block {
  display: inline-block;
}
:host ::ng-deep .backroundStyle {
  background-repeat: no-repeat;
}
:host ::ng-deep .content-background {
  --background: #eaeaea;
}
:host ::ng-deep ion-content {
  height: 100%;
  /* max-height: 600px; */
  width: 100%;
}
:host ::ng-deep ion-content {
  background: none;
  --background: none;
}
:host ::ng-deep ion-list.circle-list {
  padding: 10px;
  border-radius: 10px;
  margin: 10px;
}
:host ::ng-deep .verticaltop {
  vertical-align: top;
}
:host ::ng-deep .full-width {
  width: 100%;
}
:host ::ng-deep .full-width-sub ion-badge {
  margin: 0 auto;
}
:host ::ng-deep .full-height {
  height: 100%;
}
:host ::ng-deep ion-list {
  background: none;
}
:host ::ng-deep ion-list.list-ios {
  margin-top: 15px;
  margin-bottom: 15px;
}
:host ::ng-deep ion-card {
  border-radius: 7px;
}
:host ::ng-deep .bold {
  font-weight: bold;
}
:host ::ng-deep .margin-auto {
  margin: 0 auto;
}
:host ::ng-deep .margin-horizontal {
  margin: 0 5px;
}
:host ::ng-deep .margin-right {
  margin-right: auto;
}
:host ::ng-deep .margin-start {
  margin-inline-start: var(--ion-margin, auto);
}
:host ::ng-deep .no-padding-vertical {
  padding-top: 0;
  padding-bottom: 0;
}
:host ::ng-deep .error {
  color: #f44336;
}
:host ::ng-deep ion-split-pane.menu-split-pane {
  --side-min-width: 330px;
}
:host ::ng-deep ion-menu.app-menu {
  --background: none;
}
:host ::ng-deep ion-menu.app-menu .menu-content {
  background: #f5f5f5;
  margin: 0;
  padding: 0;
}
:host ::ng-deep ion-menu.app-menu .menu-content ion-item {
  --background: #f5f5f5;
  background: #f5f5f5;
}
:host ::ng-deep ion-menu.app-menu .menu-content .menu-header ion-label {
  margin: 0 5px;
}
:host ::ng-deep ion-menu.app-menu .menu-content .menu-header ion-icon {
  font-weight: bold;
}
:host ::ng-deep ion-menu.app-menu .menu-content .menu-list {
  padding: 0;
}
:host ::ng-deep ion-menu.app-menu .menu-content .menu-list ion-item:hover {
  font-weight: bold;
  cursor: pointer;
}
:host ::ng-deep ion-menu.app-menu .menu-content .menu-list ion-item.divider {
  --background: var(--button-b-background);
  --color: var(--button-b-text);
}
:host ::ng-deep ion-menu.app-menu .menu-content .menu-list ion-item.divider ion-icon {
  --color: var(--button-b-text);
  color: var(--button-b-text);
}
:host ::ng-deep ion-menu.app-menu .menu-content .menu-list ion-item.divider ion-label {
  padding: 0 3px;
}
:host ::ng-deep ion-menu.app-menu .menu-content .menu-list ion-item-divider ion-label {
  font-family: GadiAlmogAlefAlefAlef;
}
:host ::ng-deep ion-menu.app-menu .menu-content .menu-list ion-item.active {
  font-weight: bold;
}
:host ::ng-deep ion-menu.app-menu .menu-content .menu-list ion-item img {
  width: 35px;
  height: auto;
  vertical-align: bottom;
}
:host ::ng-deep ion-menu.app-menu .menu-content .menu-list .menu-page, :host ::ng-deep ion-menu.app-menu .menu-content .menu-list ion-item-divider {
  padding: 0 15px;
  background: none;
}
:host ::ng-deep ion-menu.app-menu .menu-content .menu-list .menu-page ion-label, :host ::ng-deep ion-menu.app-menu .menu-content .menu-list ion-item-divider ion-label {
  margin: 0 5px;
}
:host ::ng-deep ion-menu.app-menu .menu-content .menu-list .menu-page.active {
  font-weight: bold;
  color: var(--button-a-background);
}
:host ::ng-deep ion-menu.app-menu .menu-content .menu-list .template-box {
  max-height: 300px;
  overflow: scroll;
  overscroll-behavior: contain;
  overflow-x: hidden;
  padding: 0 5px;
}
:host ::ng-deep ion-menu.app-menu .menu-content .menu-list .template-box ::ng-deep .model-box {
  height: 70px;
  width: 95%;
}
:host ::ng-deep ion-menu.app-menu .menu-content .menu-list .template-box ::ng-deep .model-box .img-box {
  height: 70px;
}
:host ::ng-deep ion-menu.app-menu .menu-content .menu-list .template-box ::ng-deep .model-box .name-box {
  padding: 2px 5px;
  font-size: 0.7px;
}
:host ::ng-deep ion-menu.app-menu .menu-content .menu-list .template-box::-webkit-scrollbar {
  width: 5px;
}
:host ::ng-deep ion-menu.app-menu .menu-content .menu-list .template-box::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
:host ::ng-deep ion-menu.app-menu .menu-content .menu-list .template-box::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
}
:host ::ng-deep ion-menu.app-menu ion-list { /* optional, but it needs when you use gradient as a background color.*/
  background: transparent;
}
:host ::ng-deep ion-menu.app-menu .menu-page .menu-page-icon {
  font-size: 30px;
}
:host ::ng-deep ion-menu.app-menu .menu-page .menu-page-img {
  margin: 0 5px;
}
:host ::ng-deep ion-menu.app-menu .menu-page .menu-page-img img {
  width: 20px;
  height: auto;
  vertical-align: bottom;
}
@media (max-width: 1000px) {
  :host ::ng-deep ion-menu.app-menu {
    border: 0;
  }
}
:host ::ng-deep ion-buttons.secondary {
  position: absolute;
  left: 0;
}
:host ::ng-deep ion-radio {
  border: 1px solid #dcdcdc;
  border-radius: 11px;
  width: 20px;
  height: 20px;
  padding: 0 0px;
}
:host ::ng-deep ion-segment {
  margin-top: 5px;
  border-radius: 0;
}
:host ::ng-deep ion-badge {
  z-index: 5;
}
:host ::ng-deep ion-alert .alert-radio-group .alert-button-inner .alert-radio-label {
  white-space: initial;
}
:host ::ng-deep .modal-header ion-toolbar {
  --background: var(--main-top);
  color: var(--main-top-text);
  --ion-toolbar-color: var(--main-top-text);
}
:host ::ng-deep .modal-header ion-toolbar ion-buttons ion-button.button-clear {
  --color: var(--main-top-text);
  --color-activated: var(--main-top-text);
}
:host ::ng-deep ion-list.no-margin, :host ::ng-deep ion-list.list-ios.no-margin {
  margin: 0;
}
:host ::ng-deep ion-app ion-alert .alert-radio-group .alert-button-inner .alert-radio-label {
  text-align: right;
  padding: 13px 35px;
}
:host ::ng-deep .element-background .backgroundWhite, :host ::ng-deep .element-background .element-box, :host ::ng-deep .element-background ion-item, :host ::ng-deep .element-background ion-item-divider, :host ::ng-deep .element-background ion-label, :host ::ng-deep .element-background p, :host ::ng-deep .element-background ion-note, :host ::ng-deep .element-background .input-form, :host ::ng-deep .element-background .field-text, :host ::ng-deep .element-background ion-card-header {
  color: var(--element-color);
  --color: var(--element-color);
}
:host ::ng-deep ion-segment ion-segment-button {
  --padding-start: 10px;
  --padding-end: 10px;
  --padding-top: 5px;
  --padding-bottom: 5px;
  font-size: 15px;
}
:host ::ng-deep ion-segment ion-segment-button, :host ::ng-deep ion-segment .md ion-segment-button {
  --color-focused: var(--button-b-background);
  --color-checked: var(--button-b-background);
  --background--checked: #fff;
  --color: var(--button-a-background);
  background: #fff;
  border-radius: 0;
  min-width: 100px;
  white-space: pre-line;
}
:host ::ng-deep ion-segment .ios ion-segment-button {
  --background-focused: var(--button-b-background);
  --background-checked: var(--button-b-background);
  --color-focused: var(--button-b-text);
  --color-checked: var(--button-b-text);
  --color: var(--button-b-background);
  --border-width: 0;
  border-radius: 0;
  min-width: 100px;
}
:host ::ng-deep .noStyle ion-card {
  border-radius: 0;
  box-shadow: none;
}
:host ::ng-deep .toast-position-on-bottom {
  bottom: 55px;
  height: auto;
}
:host ::ng-deep .toast-position-on-top {
  top: 55px;
  height: auto;
}
:host ::ng-deep .input-form {
  color: #000;
  margin-top: 10px;
  background: #fff;
  border-radius: 10px;
}
:host ::ng-deep .input-form.padding-x {
  padding: 0 10px;
}
:host ::ng-deep .input-form .title {
  text-align: center;
  font-weight: bold;
  margin-bottom: 5px;
  font-size: 18px;
}
:host ::ng-deep .input-form autofield .field-box {
  padding: 2px 0;
  background: none;
}
:host ::ng-deep .input-form autofield .field-text {
  background: none;
  border: 0;
  border-radius: 0;
  border-style: solid;
}
:host ::ng-deep .input-form autofield .field-box input {
  background: none;
  padding: 3px;
  margin: 0;
}
:host ::ng-deep .input-form .ltr autofield .field-box input {
  text-align: left;
}
:host ::ng-deep .input-form autofield .field-text .datetime-md {
  padding: 2px;
  font-size: 18px;
}
:host ::ng-deep .input-form autofield .field-box textarea {
  background: none;
}
:host ::ng-deep .input-form .input-row {
  padding: 2px 15px;
  border-bottom: 1px solid #e8e8e8;
}
:host ::ng-deep .input-form .input-row-div:last-child .input-row {
  border-bottom: 0;
}
:host ::ng-deep .input-form .input-row.boolean autofield .field-text {
  border: 0;
}
:host ::ng-deep .input-form .input-row.boolean .value.active autofield .field-text {
  color: #000;
}
:host ::ng-deep .input-form .input-row.warning {
  border-color: #F44336;
  color: #F44336;
}
:host ::ng-deep .input-form .input-row .value {
  text-align: start;
}
:host ::ng-deep .input-form .input-row.boolean .value:last-child {
  border: 0;
}
:host ::ng-deep .input-form .input-row.boolean .value.active {
  background: #fac75a;
  color: #000;
  font-weight: bold;
}
:host ::ng-deep .input-form .label {
  padding: 5px;
  text-align: start;
  font-size: 14px;
}
:host ::ng-deep .input-form autofield ion-col {
  padding: 0;
}
:host ::ng-deep .input-form autofield .field-text textarea {
  padding: 0;
}
:host ::ng-deep .input-form autofield .checkbox-md-dark .checkbox-checked, :host ::ng-deep .input-form autofield .checkbox-md-dark .checkbox-icon {
  border-color: #787878;
  background: none;
}
:host ::ng-deep .input-form ion-checkbox {
  margin-top: 5px;
}
:host ::ng-deep .input-form.error {
  background: #bf3434;
  color: #fff;
  box-shadow: inset 0px 0px 0px 2px #fff;
}
:host ::ng-deep .input-form.error ion-checkbox {
  --background: #bf3434;
  --border-color: #fff;
  --background-checked: #fff;
  --border-color-checked: #fff;
  --checkmark-color: #bf3434;
}

/* colors */
:host ::ng-deep .top-row {
  background: var(--main-top);
  color: var(--main-top-text);
}
:host ::ng-deep .button-a {
  --background: linear-gradient(30deg, var(--button-a-background) 99%, var(--button-a-background) 0%, var(--button-b-background) 100%);
  color: var(--button-a-text);
  background: linear-gradient(30deg, var(--button-a-background) 99%, var(--button-a-background) 0%, var(--button-b-background) 100%);
  --background-activated: var(--button-a-over);
  --background-focused: var(--button-a-over);
  --background-hover: var(--button-a-over);
}
:host ::ng-deep .button-a ion-spinner {
  color: var(--button-a-text);
}
:host ::ng-deep .button-b {
  --background: var(--button-b-background);
  background: var(--button-b-background);
  color: var(--button-b-text);
  --background-activated: var(--button-b-over);
  --background-focused: var(--button-b-over);
  --background-hover: var(--button-b-over);
}
:host ::ng-deep .button-b ion-spinner {
  color: var(--button-b-text);
}
:host ::ng-deep .color-b {
  --color: var(--button-b-background);
  color: var(--button-b-background);
}
:host ::ng-deep .button-a.danger, :host ::ng-deep .button-b.danger {
  --background: var(--ion-color-danger);
  background: var(--ion-color-danger);
  color: #fff;
  --color: #fff;
}
:host ::ng-deep .button-a.primary, :host ::ng-deep .button-b.primary {
  --background: var(--ion-color-primary);
  background: var(--ion-color-primary);
  color: #fff;
  --color: #fff;
}
:host ::ng-deep .note-popover .bar, :host ::ng-deep .center-popover .popover-content {
  background: var(--main-top);
  color: var(--main-top-text);
  top: 110px !important;
}
:host ::ng-deep .title-row {
  background: var(--button-b-background);
  color: var(--button-b-text);
}
:host ::ng-deep .animation .from-top.hidden {
  top: -200px;
}
:host ::ng-deep .animation .from-top.show {
  top: 0;
}
:host ::ng-deep .animation .from-top {
  transition: top 0.5s ease-in-out;
}
:host ::ng-deep .animation .from-bottom.hidden {
  bottom: -200px;
}
:host ::ng-deep .animation .from-bottom.show {
  bottom: 0;
}
:host ::ng-deep .animation .from-bottom {
  transition: bottom 0.5s ease-in-out;
}
:host ::ng-deep .no-animation .animation .from-top, :host ::ng-deep .no-animation .animation .from-bottom {
  transition: initial;
}
:host ::ng-deep ion-toast.no-shadow {
  box-shadow: none;
  --box-shadow: none;
}
:host ::ng-deep ion-toast.no-shadow .toast-wrapper {
  box-shadow: none !important;
}

.active-btn {
  position: absolute;
  top: 0;
  z-index: 200;
  left: 0;
}

ion-menu.app-menu.active-box {
  display: none;
}

.app-menu.active-box.active {
  display: initial;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EA8JE,UAAA;EAkPA,qBAAA;EAifA,eAAA;EA8KA,QAAA;AA1iCF;AAJE;EAEE,YAAA;AAKJ;AAAA;;EAEE,0BAAA;AAEF;AACA;;EAEE,4BAAA;AACF;AAEA;;EAEE,4BAAA;AAAF;AAGA;;EAEE,4BAAA;AADF;AAIE;EACE,8BAAA;AAFJ;AAKE;EACE,4BAAA;AAHJ;AAYE;EACE,gBAAA;EACA,4BAAA;AAVJ;AAuBE;EACE,kBAAA;EAGA,aAAA;AAvBJ;AAyBI;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAvBN;AA4BE;EACE;IACE,gBAAA;EA1BJ;AACF;AAgCE;EACE,iBAAA;EACA,YAAA;EACA,gBAAA;AA9BJ;AAkCE;EACE,WAAA;EACA,YAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,2BAAA;EACA,4BAAA;AAhCJ;AAmCE;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AAjCJ;AAqCE;EAKE,uCAAA;AAnCJ;AAsCE;EACE,eAAA;AApCJ;AAuCE;EACE,kBAAA;AArCJ;AAwCE;EACE,sBAAA;EACA,2BAAA;AAtCJ;AAyCE;EACE,UAAA;AAvCJ;AA0CE;EACE,gBAAA;EACA,eAAA;AAxCJ;AA2CE;EACE,eAAA;EACA,cAAA;AAzCJ;AA4CE;EACE,aAAA;AA1CJ;AA6CE;EACE,kBAAA;EACA,iBAAA;AA3CJ;AA8CE;EACE,aAAA;EACA,kBAAA;AA5CJ;AAgDE;EACE,kBAAA;EACA,SAAA;EAEA,kBAAA;AA/CJ;AAiDI;EACE,WAAA;AA/CN;AAoDI;EACE,oBAAA;EACA,kBAAA;AAlDN;AAsDE;EACE,qBAAA;EACA,mBAAA;EACA,WAAA;AApDJ;AAuDE;EACE,qBAAA;EACA,mBAAA;EACA,WAAA;AArDJ;AAwDE;EACE,eAAA;EACA,sBAAA;AAtDJ;AA0DE;EACE,kBAAA;EACA,gBAAA;AAxDJ;AA0DI;EACE,eAAA;AAxDN;AA4DE;EACE,gBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AA1DJ;AA6DE;EACE,oBAAA;EACA,kBAAA;AA3DJ;AA8DE;EACE,gBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AA5DJ;AA+DE;EACE,YAAA;AA7DJ;AAgEE;EACE,UAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AA9DJ;AAgEI;EACE,eAAA;AA9DN;AAmEI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EAEA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,oCAAA;EACA,cAAA;AAlEN;AAqEI;EACE,sBAAA;EACA,mBAAA;EACA,WAAA;AAnEN;AAsEI;EACE,wBAAA;AApEN;AAyEE;EACE,sCAAA;EACA,YAAA;AAvEJ;AA2EE;EACE,cAAA;EACA,gBAAA;AAzEJ;AA4EE;EACE,sBAAA;EACA,mBAAA;AA1EJ;AA6EE;EACE,sBAAA;EACA,mBAAA;EACA,WAAA;AA3EJ;AA8EE;EACE,+GAAA;AA5EJ;AA+EE;EACE,wBAAA;AA7EJ;AAgFE;EACE,YAAA;AA9EJ;AAiFE;EACE,gBAAA;AA/EJ;AAkFE;EACE,eAAA;EACA,cAAA;AAhFJ;AAmFE;EACE,kBAAA;AAjFJ;AAoFE;EACE,eAAA;AAlFJ;AAqFE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,oBAAA;EACA,oCAAA;AAnFJ;AA4FE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,oCAAA;AA1FJ;AA4HE;EACE,kBAAA;AA1HJ;AA6HE;EACE,qBAAA;AA3HJ;AA8HE;EACE,qBAAA;AA5HJ;AAiIE;EACE,4BAAA;AA/HJ;AAkIE;EACE,qBAAA;AAhIJ;AAuIE;EAIE,YAAA;EACA,uBAAA;EACA,WAAA;AAxIJ;AAsJE;EACE,gBAAA;EACA,kBAAA;AApJJ;AA+JE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AA7JJ;AAgKE;EACE,mBAAA;AA9JJ;AAiKE;EACE,WAAA;AA/JJ;AAkKE;EAEE,cAAA;AAjKJ;AAoKE;EACE,YAAA;AAlKJ;AAqKE;EACE,gBAAA;AAnKJ;AAsKE;EACE,gBAAA;EACA,mBAAA;AApKJ;AAuKE;EAGE,kBAAA;AAvKJ;AA0KE;EACE,iBAAA;AAxKJ;AA2KE;EACE,cAAA;AAzKJ;AA4KE;EACE,aAAA;AA1KJ;AA6KE;EACE,kBAAA;AA3KJ;AA8KE;EACE,4CAAA;AA5KJ;AA+KE;EACE,cAAA;EACA,iBAAA;AA7KJ;AAgLE;EACE,cAAA;AA9KJ;AAsLE;EACE,uBAAA;AApLJ;AAuLE;EAEE,kBAAA;AAtLJ;AA6LI;EAGE,mBAAA;EAaA,SAAA;EACA,UAAA;AAzMN;AA4MM;EACE,qBAAA;EACA,mBAAA;AA1MR;AA8MQ;EACE,aAAA;AA5MV;AA+MQ;EACE,iBAAA;AA7MV;AAkNM;EACE,UAAA;AAhNR;AAkNQ;EACE,iBAAA;EACA,eAAA;AAhNV;AAmNQ;EACE,wCAAA;EACA,6BAAA;AAjNV;AAmNU;EACE,6BAAA;EACA,2BAAA;AAjNZ;AAoNU;EACE,cAAA;AAlNZ;AAyNU;EACE,kCAAA;AAvNZ;AAgOQ;EACE,iBAAA;AA9NV;AAkOQ;EACE,WAAA;EACA,YAAA;EACA,sBAAA;AAhOV;AAoOQ;EACE,eAAA;EACA,gBAAA;AAlOV;AAqOU;EACE,aAAA;AAnOZ;AAuOQ;EAEE,iBAAA;EACA,iCAAA;AAtOV;AA0OQ;EACE,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,kBAAA;EACA,cAAA;AAxOV;AA2OY;EACE,YAAA;EACA,UAAA;AAzOd;AA2Oc;EACE,YAAA;AAzOhB;AA4Oc;EACE,gBAAA;EACA,gBAAA;AA1OhB;AAiPQ;EACE,UAAA;AA/OV;AAkPQ;EACE,oDAAA;EACA,mBAAA;AAhPV;AAmPQ;EACE,mBAAA;EACA,oDAAA;AAjPV;AA4RI,6CAAA,uEAAA;EACE,uBAAA;AA1RN;AA+RM;EACE,eAAA;AA7RR;AAsSM;EACE,aAAA;AApSR;AAsSQ;EACE,WAAA;EACA,YAAA;EACA,sBAAA;AApSV;AA0SE;EACE;IACE,SAAA;EAxSJ;AACF;AA2SE;EACE,kBAAA;EACA,OAAA;AAzSJ;AA4SE;EACE,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA1SJ;AA6SE;EACE,eAAA;EACA,gBAAA;AA3SJ;AAkTE;EACE,UAAA;AAhTJ;AAmTE;EACE,oBAAA;AAjTJ;AA0TI;EACE,6BAAA;EACA,2BAAA;EACA,yCAAA;AAxTN;AA4TM;EACE,6BAAA;EACA,uCAAA;AA1TR;AA+TE;EACE,SAAA;AA7TJ;AAyUU;EACE,iBAAA;EACA,kBAAA;AAvUZ;AAoVI;EAGE,2BAAA;EACA,6BAAA;AApVN;AA4VI;EAEE,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;AA3VN;AAmWI;EACE,2CAAA;EACA,2CAAA;EAEA,2BAAA;EACA,mCAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EAEA,qBAAA;AAnWN;AAsWI;EACE,gDAAA;EACA,gDAAA;EAEA,qCAAA;EACA,qCAAA;EACA,mCAAA;EACA,iBAAA;EAEA,gBAAA;EACA,gBAAA;AAtWN;AA6WI;EACE,gBAAA;EAEA,gBAAA;AA5WN;AAiXE;EACE,YAAA;EACA,YAAA;AA/WJ;AAkXE;EACE,SAAA;EACA,YAAA;AAhXJ;AAoXE;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAlXJ;AAqXE;EACE,eAAA;AAnXJ;AAsXE;EAEE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AArXJ;AAwXE;EACE,cAAA;EACA,gBAAA;AAtXJ;AA0XE;EACE,gBAAA;EACA,SAAA;EAGA,gBAAA;EAEA,mBAAA;AA3XJ;AAuYE;EACE,gBAAA;EACA,YAAA;EACA,SAAA;AArYJ;AA0YE;EACE,gBAAA;AAxYJ;AA2YE;EACE,YAAA;EACA,eAAA;AAzYJ;AA4YE;EACE,gBAAA;AA1YJ;AA8YE;EACE,iBAAA;EACA,gCAAA;AA5YJ;AAmZE;EACE,gBAAA;AAjZJ;AAoZE;EACE,SAAA;AAlZJ;AAqZE;EACE,WAAA;AAnZJ;AAsZE;EACE,qBAAA;EACA,cAAA;AApZJ;AAuZE;EACE,iBAAA;AArZJ;AA6ZE;EAGE,SAAA;AA7ZJ;AAgaE;EACE,mBAAA;EACA,WAAA;EACA,iBAAA;AA9ZJ;AAiaE;EACE,YAAA;EACA,iBAAA;EACA,eAAA;AA/ZJ;AAkaE;EACE,UAAA;AAhaJ;AAmaE;EACE,UAAA;AAjaJ;AAoaE;EACE,qBAAA;EACA,gBAAA;AAlaJ;AAqaE;EAOE,eAAA;AAzaJ;AA4aE;EACE,mBAAA;EACA,WAAA;EAGA,sCAAA;AA1aJ;AA4aI;EACE,qBAAA;EACA,oBAAA;EACA,0BAAA;EACA,4BAAA;EACA,0BAAA;AA1aN;;AAgcA,WAAA;AAIE;EACE,2BAAA;EACA,2BAAA;AAhcJ;AAmcE;EAEE,oIAAA;EAEA,2BAAA;EACA,kIAAA;EAEA,4CAAA;EACA,0CAAA;EACA,wCAAA;AApcJ;AAscI;EACE,2BAAA;AApcN;AAwcE;EACE,wCAAA;EACA,sCAAA;EACA,2BAAA;EAEA,4CAAA;EACA,0CAAA;EACA,wCAAA;AAvcJ;AAycI;EACE,2BAAA;AAvcN;AA2cE;EACE,mCAAA;EACA,iCAAA;AAzcJ;AA4cE;EACE,qCAAA;EACA,mCAAA;EACA,WAAA;EACA,aAAA;AA1cJ;AA6cE;EACE,sCAAA;EACA,oCAAA;EACA,WAAA;EACA,aAAA;AA3cJ;AA8cE;EACE,2BAAA;EACA,2BAAA;EACA,qBAAA;AA5cJ;AAgdE;EACE,sCAAA;EACA,2BAAA;AA9cJ;AAqfI;EACE,WAAA;AAnfN;AAsfI;EACE,MAAA;AApfN;AAufI;EAKE,gCAAA;AArfN;AAwfI;EACE,cAAA;AAtfN;AAyfI;EACE,SAAA;AAvfN;AA0fI;EAKE,mCAAA;AAxfN;AA8fM;EAKE,mBAAA;AA5fR;AAkgBE;EACE,gBAAA;EACA,kBAAA;AAhgBJ;AAkgBI;EACE,2BAAA;AAhgBN;;AAqgBA;EACE,kBAAA;EACA,MAAA;EACA,YAAA;EACA,OAAA;AAlgBF;;AAqgBA;EACE,aAAA;AAlgBF;;AAqgBA;EACE,gBAAA;AAlgBF","sourcesContent":[":host ::ng-deep {\n  ion-app {\n    //max-width: 1000px;\n    margin: auto;\n    //box-shadow: 0px 0px 10px #c4c4c4;\n  }\n\n\n.nh1 span, .nh1 ion-icon, .nh1 ion-card-title, .nh1 div, .nh1 ion-label,\n.nh1 h1, .nh1 h2, .nh1 h3, .nh1 h4, .nh1 p, .nh1 ion-button, .nh1 div, .nh1 ion-col, .nh1 ion-card-subtitle {\n  font-size: 3rem !important;\n}\n\n.nh2 span, .nh2 ion-icon, .nh2 ion-card-title, .nh2 div, .nh2 ion-label,\n.nh2 h1, .nh2 h2, .nh2 h3, .nh2 h4, .nh2 p, .nh2 ion-button, .nh2 div, .nh2 ion-col, .nh2 ion-card-subtitle {\n  font-size: 2.3rem !important;\n}\n\n.nh3 span, .nh3 ion-icon, .nh3 ion-card-title, .nh3 div, .nh3 ion-label,\n.nh3 h1, .nh3 h2, .nh3 h3, .nh3 h4, .nh3 p, .nh3 ion-button, .nh3 div, .nh3 ion-col, .nh3 ion-card-subtitle {\n  font-size: 1.5rem !important;\n}\n\n.nh4 span, .nh4 ion-icon, .nh4 ion-card-title, .nh4 div, .nh4 ion-label,\n.nh4 h1, .nh4 h2, .nh4 h3, .nh4 h4, .nh4 p, .nh4 ion-button, .nh4 div, .nh4 ion-col, .nh4 ion-card-subtitle {\n  font-size: 1.5rem !important;\n}\n\n  .button-outline {\n    --border-width: 1px !important;\n  }\n\n  ion-badge .h1 {\n    font-size: 1.5rem !important;\n  }\n\n  //::-webkit-scrollbar,\n  //*::-webkit-scrollbar {\n  //  display: none;\n  //}\n\n\n  .showScroll {\n    overflow: scroll;\n    overscroll-behavior: contain;\n  }\n\n  ::-webkit-scrollbar {\n    //display: block;\n\n    //background: var(--ion-color-base);\n    //color: var(--ion-color-contrast);\n    //scrollbar-width: 100px;\n    //scrollbar-color: var(--thumbBG) var(--scrollbarBG);\n  }\n\n\n  .abs {\n    position: absolute;\n    //right: -3px;\n    //padding: 3px;\n    display: none;\n\n    .abs-close-btn {\n      background: #000;\n      text-align: center;\n      padding-top: 3px;\n      margin-top: -3px;\n      color: #fff;\n      border-radius: 5px;\n    }\n  }\n\n\n  @media screen and (min-width: 1400px) {\n    .abs {\n      display: inherit;\n    }\n    //.hideSM {\n    //  display: none;\n    //}\n  }\n\n  .negishotIcon {\n    background: white;\n    padding: 3px;\n    text-align: left;\n  }\n\n\n  .app-loading-page-sub {\n    width: 100%;\n    height: 100%;\n    background-size: 100% 100%;\n    max-width: 1000px;\n    margin: 0 auto;\n    background-position: center;\n    background-repeat: no-repeat;\n  }\n\n  .app-loading-page {\n    height: 100%;\n    width: 100%;\n    display: initial;\n    position: absolute;\n    z-index: 200;\n\n  }\n\n  .topheader-fade {\n    -webkit-transition: margin-top 0.3s ease-in-out;\n    -moz-transition: margin-top 0.3s ease-in-out;\n    -ms-transition: margin-top 0.3s ease-in-out;\n    -o-transition: margin-top 0.3s ease-in-out;\n    transition: margin-top 0.3s ease-in-out;\n  }\n\n  .topheader-fade-off {\n    margin-top: 0px;\n  }\n\n  .topheader-fade-on {\n    margin-top: -100px;\n  }\n\n  .app-loading-page.bis-loading {\n    background-size: cover;\n    background-position: center;\n  }\n\n  .no-padding {\n    padding: 0;\n  }\n\n  .no-padding-x {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .no-margin-x {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .no-margin-top {\n    margin-top: 0;\n  }\n\n  .padding-x {\n    padding-right: 5px;\n    padding-left: 5px;\n  }\n\n  .top-row {\n    padding: 10px;\n    text-align: center;\n  }\n\n  /*buttons*/\n  .button-a, .button-b {\n    border-radius: 8px;\n    border: 0;\n    //line-height: 30px;\n    text-align: center;\n\n    ion-spinner {\n      width: 20px;\n    }\n  }\n\n  ion-buttons {\n    ion-button.button-a, ion-button.button-b {\n      --border-radius: 5px;\n      border-radius: 5px;\n    }\n  }\n\n  .button-a.success {\n    --background: #7bb078;\n    background: #7bb078;\n    color: #fff;\n  }\n\n  .button-a.warning {\n    --background: #f44336;\n    background: #f44336;\n    color: #fff;\n  }\n\n  .button-a ion-icon, .button-b ion-icon {\n    font-size: 17px;\n    vertical-align: middle;\n    //padding: 0 2px 0 0;\n  }\n\n  .button-a.big-icon, .button-b.big-icon {\n    --padding-start: 0;\n    --padding-end: 0;\n\n    ion-icon {\n      font-size: 30px;\n    }\n  }\n\n  .button-a.big, .button-b.big, .button-a.button-big, .button-a.button-big {\n    font-weight: 700;\n    width: 60%;\n    height: 60px;\n    font-size: 26px;\n    margin: 15px auto;\n  }\n\n  .button-a.trash, .button-b.trash {\n    --padding-start: 5px;\n    --padding-end: 5px;\n  }\n\n  .button-a.medium, .button-b.medium {\n    font-weight: 700;\n    width: 40%;\n    height: 50px;\n    font-size: 20px;\n    margin: 15px auto;\n  }\n\n  .button-a.small, .button-b.small {\n    height: 30px;\n  }\n\n  .title-row {\n    width: 90%;\n    text-align: center;\n    padding: 5px;\n    margin: 5px auto;\n    border-radius: 5px;\n\n    .title-icon {\n      font-size: 20px;\n    }\n  }\n\n  .section-box {\n    .title-box {\n      position: absolute;\n      bottom: 0px;\n      z-index: 7;\n      //background: var(--button-a-background);\n      background: #000;\n      width: 100%;\n      opacity: 0.7;\n      line-height: 1;\n      padding: 3px;\n      height: 30px;\n      font-weight: 700;\n      text-align: center;\n      color: var(--button-b-text);\n      box-shadow: 0px 5px 22px 3px #979797;\n      display: table;\n    }\n\n    .title-box span {\n      vertical-align: middle;\n      display: table-cell;\n      width: 100%;\n    }\n\n    .title-box p {\n      display: table-row-group;\n    }\n  }\n\n\n  .ticket-dividerMark {\n    background: var(--button-a-background);\n    padding: 3px;\n  }\n\n\n  .vert-center, .vert-bottom {\n    display: table;\n    min-height: 56px;\n  }\n\n  .vert-center .vert-box {\n    vertical-align: middle;\n    display: table-cell;\n  }\n\n  .vert-bottom .vert-box {\n    vertical-align: bottom;\n    display: table-cell;\n    width: 100%;\n  }\n\n  .box-shadow {\n    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);\n  }\n\n  .background-contain {\n    background-size: contain;\n  }\n\n  .padding-5 {\n    padding: 5px;\n  }\n\n  .margin-top {\n    margin-top: 10px;\n  }\n\n  .no-margin-x {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .relative {\n    position: relative;\n  }\n\n  .position-fixed {\n    position: fixed;\n  }\n\n  .relative .name-box {\n    position: absolute;\n    color: #fff;\n    z-index: 25;\n    bottom: 0;\n    width: 100%;\n    text-shadow: 1px 1px 3px #000;\n    padding: 0 35px;\n    /* font-size: 29px; */\n    font-size: 20px;\n    padding-bottom: 10px;\n    background-color: rgba(0, 0, 0, 0.4);\n  }\n\n  .quick-cart-box {\n    //width: 33%;\n    //position: fixed;\n    //max-height: 900px;\n  }\n\n  .on-image-title {\n    position: absolute;\n    color: #fff;\n    z-index: 25;\n    bottom: 0;\n    width: 100%;\n    text-shadow: 1px 1px 3px #000;\n    /* padding: 0 35px; */\n    text-align: center;\n    font-size: 15px;\n    /* padding-bottom: 10px; */\n    background-color: rgba(0, 0, 0, 0.4);\n  }\n\n  //.ion-paddsmall {\n  //  //padding: 5px;\n  //  //background: white;\n  //  border: 5px solid #e1e1e1;\n  //}\n\n\n  //@media screen and (max-width: 700px) {\n  //  .title {\n  //    font-size: 1rem;\n  //  }\n  //  .subTitle {\n  //    font-size: 0.8rem;\n  //  }\n  //}\n\n\n  //@media screen and (min-width: 700px) {\n  //  .relative .name-box {\n  //    font-size: 2.2rem;\n  //    //text-align: center;\n  //  }\n  //  .title {\n  //    font-size: 1.4rem;\n  //  }\n  //  .subTitle {\n  //    font-size: 1rem;\n  //  }\n  //}\n\n\n  .absolute {\n    position: absolute;\n  }\n\n  .pre-line {\n    white-space: pre-line;\n  }\n\n  .inline-block {\n    display: inline-block;\n  }\n\n  /* ionic components */\n\n  .backroundStyle {\n    background-repeat: no-repeat;\n  }\n\n  .content-background {\n    --background: #eaeaea;\n  }\n\n  .cart-content, .body-content {\n    //--background: #eaeaea;\n  }\n\n  ion-content {\n    //background: none;\n    //--background: none;\n\n    height: 100%;\n    /* max-height: 600px; */\n    width: 100%;\n    //--background: hsla(200, 40%, 30%, .2);\n    //background-color: hsla(200, 40%, 30%, 0.2);\n    //background-image: url('https://78.media.tumblr.com/8cd0a12b7d9d5ba2c7d26f42c25de99f/tumblr_p7n8kqHMuD1uy4lhuo2_1280.png'),\n    //url('https://78.media.tumblr.com/5ecb41b654f4e8878f59445b948ede50/tumblr_p7n8on19cV1uy4lhuo1_1280.png'),\n    //url('https://78.media.tumblr.com/28bd9a2522fbf8981d680317ccbf4282/tumblr_p7n8kqHMuD1uy4lhuo3_1280.png'),\n    //url('https://78.media.tumblr.com/8cd0a12b7d9d5ba2c7d26f42c25de99f/tumblr_p7n8kqHMuD1uy4lhuo2_1280.png'),\n    //url('https://78.media.tumblr.com/28bd9a2522fbf8981d680317ccbf4282/tumblr_p7n8kqHMuD1uy4lhuo3_1280.png');\n    //background-repeat: repeat-x;\n    //background-position: 0 20%, 0 100%, 0 50%, 0 100%, 0 0;\n    //background-size: 2500px, 800px, 500px 200px, 1000px, 400px 260px;\n    //animation: 1000s para infinite linear;\n  }\n\n  ion-content {\n    background: none;\n    --background: none;\n    //display: none;\n    //--offset-bottom: auto !important;\n    //--overflow: hidden;\n    //overflow: auto;\n    //\n    //&::-webkit-scrollbar {\n    //  display: none;\n    //}\n  }\n\n  ion-list.circle-list {\n    padding: 10px;\n    border-radius: 10px;\n    margin: 10px;\n  }\n\n  .verticaltop {\n    vertical-align: top;\n  }\n\n  .full-width {\n    width: 100%;\n  }\n\n  .full-width-sub ion-badge {\n    //width: 100%;\n    margin: 0 auto;\n  }\n\n  .full-height {\n    height: 100%;\n  }\n\n  ion-list {\n    background: none;\n  }\n\n  ion-list.list-ios {\n    margin-top: 15px;\n    margin-bottom: 15px;\n  }\n\n  ion-card {\n    //background: #fff;\n\n    border-radius: 7px;\n  }\n\n  .bold {\n    font-weight: bold;\n  }\n\n  .margin-auto {\n    margin: 0 auto;\n  }\n\n  .margin-horizontal {\n    margin: 0 5px;\n  }\n\n  .margin-right {\n    margin-right: auto;\n  }\n\n  .margin-start {\n    margin-inline-start: var(--ion-margin, auto);\n  }\n\n  .no-padding-vertical {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .error {\n    color: #f44336;\n  }\n\n  //ion-label {\n  //  span {\n  //    margin: 0 3px;\n  //  }\n  //}\n  ion-split-pane.menu-split-pane {\n    --side-min-width: 330px;\n  }\n\n  ion-menu.app-menu {\n    //--width: 230px;\n    --background: none;\n    //position: absolute;\n    //z-index: 500;\n    //top:55px;\n    //border: 0;\n    //--width:250px;\n\n    .menu-content {\n\n      //margin: 7px 0;\n      background: #f5f5f5;\n      //overflow: hidden;\n      //height: 100%;\n      //border-bottom-left-radius: 15px;\n      //border-top-left-radius: 15px;\n\n      //max-height: 100%;\n      //overflow: scroll;\n      //overscroll-behavior: contain;\n      //overscroll-behavior: contain;\n      //overflow-x: hidden;\n      //max-width: 230px;\n\n      margin: 0;\n      padding: 0;\n\n\n      ion-item {\n        --background: #f5f5f5;\n        background: #f5f5f5;\n      }\n\n      .menu-header {\n        ion-label {\n          margin: 0 5px;\n        }\n\n        ion-icon {\n          font-weight: bold;\n          //color: var(--button-a-background);\n        }\n      }\n\n      .menu-list {\n        padding: 0;\n\n        ion-item:hover {\n          font-weight: bold;\n          cursor: pointer;\n        }\n\n        ion-item.divider {\n          --background: var(--button-b-background);\n          --color: var(--button-b-text);\n\n          ion-icon {\n            --color: var(--button-b-text);\n            color: var(--button-b-text);\n          }\n\n          ion-label {\n            padding: 0 3px;\n          }\n\n        }\n\n        ion-item-divider {\n\n          ion-label {\n            font-family: GadiAlmogAlefAlefAlef;\n          }\n\n          //ion-label, ion-icon {\n          //  --color: var(--button-a-background);\n          //  color: var(--button-a-background);\n          //}\n        }\n\n        ion-item.active {\n          font-weight: bold;\n          //color: var(--button-a-background);\n        }\n\n        ion-item img {\n          width: 35px;\n          height: auto;\n          vertical-align: bottom;\n        }\n\n\n        .menu-page, ion-item-divider {\n          padding: 0 15px;\n          background: none;\n          //font-size: 0.8rem;\n\n          ion-label {\n            margin: 0 5px;\n          }\n        }\n\n        .menu-page.active {\n          //--background: #dcdadb;\n          font-weight: bold;\n          color: var(--button-a-background);\n\n        }\n\n        .template-box {\n          max-height: 300px;\n          overflow: scroll;\n          overscroll-behavior: contain;\n          overflow-x: hidden;\n          padding: 0 5px;\n\n          ::ng-deep {\n            .model-box {\n              height: 70px;\n              width: 95%;\n\n              .img-box {\n                height: 70px;\n              }\n\n              .name-box {\n                padding: 2px 5px;\n                font-size: 0.7px;\n              }\n            }\n          }\n        }\n\n        //scrollbar design\n        .template-box::-webkit-scrollbar {\n          width: 5px;\n        }\n\n        .template-box::-webkit-scrollbar-track {\n          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n          border-radius: 10px;\n        }\n\n        .template-box::-webkit-scrollbar-thumb {\n          border-radius: 10px;\n          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);\n        }\n\n\n      }\n\n\n    }\n\n    //scrollbar design\n    //.menu-content::-webkit-scrollbar {\n    //  width: 5px;\n    //}\n    //\n    //.menu-content::-webkit-scrollbar-track {\n    //  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    //  border-radius: 10px;\n    //}\n    //\n    //.menu-content::-webkit-scrollbar-thumb {\n    //  border-radius: 10px;\n    //  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);\n    //}\n\n\n    //border: 1px solid #e3e3e2;\n    ////--ion-background-color: var(--ion-color-primary);\n    ////--ion-text-color: var(--ion-color-primary-contrast);\n    //\n    //margin: 7px;\n    //border-radius: 15px;\n\n    //.menu-header {\n    //  --background: var(--button-a-background);\n    //  color: var(--button-a-text);\n    //\n    //  .menu-icon {\n    //    font-size: 60px;\n    //    color: var(--button-a-text);\n    //    margin: 5px;\n    //  }\n    //}\n\n    ion-list { /* optional, but it needs when you use gradient as a background color.*/\n      background: transparent;\n    }\n\n\n    .menu-page {\n      .menu-page-icon {\n        font-size: 30px;\n        //margin: 0 0 0 30px;\n      }\n\n      //.menu-page-title {\n      //  font-size: 18px;\n      //  margin: 0 10px;\n      //}\n\n      .menu-page-img {\n        margin: 0 5px;\n\n        img {\n          width: 20px;\n          height: auto;\n          vertical-align: bottom;\n        }\n      }\n    }\n  }\n\n  @media (max-width: 1000px) {\n    ion-menu.app-menu {\n      border: 0;\n    }\n  }\n\n  ion-buttons.secondary {\n    position: absolute;\n    left: 0;\n  }\n\n  ion-radio {\n    border: 1px solid #dcdcdc;\n    border-radius: 11px;\n    width: 20px;\n    height: 20px;\n    padding: 0 0px;\n  }\n\n  ion-segment {\n    margin-top: 5px;\n    border-radius: 0;\n\n    ion-segment-button {\n      //--background-checked: var(--button-b-background);\n    }\n  }\n\n  ion-badge {\n    z-index: 5;\n  }\n\n  ion-alert .alert-radio-group .alert-button-inner .alert-radio-label {\n    white-space: initial;\n  }\n\n\n  //ion-toolbar.modal {\n  //  direction: var(--app-direction);\n  //}\n\n  .modal-header {\n    ion-toolbar {\n      --background: var(--main-top);\n      color: var(--main-top-text);\n      --ion-toolbar-color: var(--main-top-text);\n      //direction: var(--app-direction);\n\n\n      ion-buttons ion-button.button-clear {\n        --color: var(--main-top-text);\n        --color-activated: var(--main-top-text);\n      }\n    }\n  }\n\n  ion-list.no-margin, ion-list.list-ios.no-margin {\n    margin: 0;\n  }\n\n\n  ion-app {\n    ion-alert {\n      .alert-radio-group {\n        .alert-button-inner {\n          .alert-radio-icon {\n            //left: -23px;\n          }\n\n          .alert-radio-label {\n            text-align: right;\n            padding: 13px 35px;\n          }\n        }\n      }\n    }\n  }\n\n  .element-background {\n    //background: var(--element-background);\n    //--background: var(--element-background);\n    //color: var(--element-color);\n    //--color: var(--element-color);\n\n    .backgroundWhite, .element-box, ion-item, ion-item-divider, ion-label, p, ion-note, .input-form, .field-text, ion-card-header {\n      //background: var(--element-background);\n      //--background: var(--element-background);\n      color: var(--element-color);\n      --color: var(--element-color);\n    }\n  }\n\n\n  ion-segment {\n    //display: inline-block;\n\n    ion-segment-button {\n\n      --padding-start: 10px;\n      --padding-end: 10px;\n      --padding-top: 5px;\n      --padding-bottom: 5px;\n      font-size: 15px;\n\n      //--border-color: var(--button-a-background);\n      //--color: var(--main-top-text);\n\n      //--background: var(--main-top);\n    }\n\n    ion-segment-button, .md ion-segment-button {\n      --color-focused: var(--button-b-background);\n      --color-checked: var(--button-b-background);\n\n      --background--checked: #fff;\n      --color: var(--button-a-background);\n      background: #fff;\n      border-radius: 0;\n      min-width: 100px;\n\n      white-space: pre-line;\n    }\n\n    .ios ion-segment-button {\n      --background-focused: var(--button-b-background);\n      --background-checked: var(--button-b-background);\n\n      --color-focused: var(--button-b-text);\n      --color-checked: var(--button-b-text);\n      --color: var(--button-b-background);\n      --border-width: 0;\n\n      border-radius: 0;\n      min-width: 100px;\n    }\n  }\n\n  .noStyle {\n    //padding: 2px;\n\n    ion-card {\n      border-radius: 0;\n      //background: none;\n      box-shadow: none;\n    }\n  }\n\n\n  .toast-position-on-bottom {\n    bottom: 55px;\n    height: auto;\n  }\n\n  .toast-position-on-top {\n    top: 55px;\n    height: auto;\n  }\n\n  /* input-form */\n  .input-form {\n    color: #000;\n    margin-top: 10px;\n    background: #fff;\n    border-radius: 10px;\n  }\n\n  .input-form.padding-x {\n    padding: 0 10px;\n  }\n\n  .input-form .title {\n    //color: #fff;\n    text-align: center;\n    font-weight: bold;\n    margin-bottom: 5px;\n    font-size: 18px;\n  }\n\n  .input-form autofield .field-box {\n    padding: 2px 0;\n    background: none;;\n\n  }\n\n  .input-form autofield .field-text {\n    background: none;\n    border: 0;\n    //color: #fff;\n\n    border-radius: 0;\n    //border-color: #35332c;\n    border-style: solid;\n\n    //border-right-width: 1px;\n    //border-left-width: 0px;\n  }\n\n  .input-form .ltr autofield .field-text {\n    //border-right-width: 0px;\n    //border-left-width: 1px;\n    //text-align: left;\n  }\n\n  .input-form autofield .field-box input {\n    background: none;\n    padding: 3px;\n    margin: 0;\n    //text-align: right;\n\n  }\n\n  .input-form .ltr autofield .field-box input {\n    text-align: left;\n  }\n\n  .input-form autofield .field-text .datetime-md {\n    padding: 2px;\n    font-size: 18px;\n  }\n\n  .input-form autofield .field-box textarea {\n    background: none;\n  }\n\n\n  .input-form .input-row {\n    padding: 2px 15px;\n    border-bottom: 1px solid #e8e8e8;\n  }\n\n  //.input-form .input-row.clickable:active {\n  //  background: #ccc;\n  //}\n\n  .input-form .input-row-div:last-child .input-row {\n    border-bottom: 0;\n  }\n\n  .input-form .input-row.boolean autofield .field-text {\n    border: 0;\n  }\n\n  .input-form .input-row.boolean .value.active autofield .field-text {\n    color: #000;\n  }\n\n  .input-form .input-row.warning {\n    border-color: #F44336;\n    color: #F44336;\n  }\n\n  .input-form .input-row .value {\n    text-align: start;\n  }\n\n  .input-form .input-row.boolean .value {\n    //text-align: center;\n    //border-left: 1px solid #bda15b;\n  }\n\n  .input-form .input-row.boolean .value:last-child {\n    //border-bottom-left-radius: 9px;\n    //border-top-left-radius: 9px;\n    border: 0;\n  }\n\n  .input-form .input-row.boolean .value.active {\n    background: #fac75a;\n    color: #000;\n    font-weight: bold;\n  }\n\n  .input-form .label {\n    padding: 5px;\n    text-align: start;\n    font-size: 14px;\n  }\n\n  .input-form autofield ion-col {\n    padding: 0;\n  }\n\n  .input-form autofield .field-text textarea {\n    padding: 0;\n  }\n\n  .input-form autofield .checkbox-md-dark .checkbox-checked, .input-form autofield .checkbox-md-dark .checkbox-icon {\n    border-color: #787878;\n    background: none;\n  }\n\n  .input-form ion-checkbox {\n    //--checkmark-color: #000000;\n    //--color: #000;\n    //--background: #252525;\n    //--background-checked: #fac75a;\n    //--border-color: #fac75a;\n    //--border-color-checked: #fac75a;\n    margin-top: 5px\n  }\n\n  .input-form.error {\n    background: #bf3434;\n    color: #fff;\n    -webkit-box-shadow: inset 0px 0px 0px 10px #f00;\n    -moz-box-shadow: inset 0px 0px 0px 10px #f00;\n    box-shadow: inset 0px 0px 0px 2px #fff;\n\n    ion-checkbox {\n      --background: #bf3434;\n      --border-color: #fff;\n      --background-checked: #fff;\n      --border-color-checked: #fff;\n      --checkmark-color: #bf3434;\n    }\n  }\n\n  //\n  //.register-loading {\n  //  --background: #222;\n  //  --spinner-color: #fff;\n  //\n  //  color: #fff;\n  //\n  //  --backdrop-opacity:1;\n  //\n  //  //ion-backdrop {\n  //  //    top: 15%;\n  //  //    height: 70%;\n  //  //}\n  //}\n\n  /* end */\n}\n\n/* colors */\n\n:host ::ng-deep {\n\n  .top-row {\n    background: var(--main-top);\n    color: var(--main-top-text);\n  }\n\n  .button-a {\n    //--background: var(--button-a-background);\n    --background: linear-gradient(30deg, var(--button-a-background) 99%, var(--button-a-background) 0%, var(--button-b-background) 100%);\n    //background: var(--button-a-background);\n    color: var(--button-a-text);\n    background: linear-gradient(30deg, var(--button-a-background) 99%, var(--button-a-background) 0%, var(--button-b-background) 100%);\n\n    --background-activated: var(--button-a-over);\n    --background-focused: var(--button-a-over);\n    --background-hover: var(--button-a-over);\n\n    ion-spinner {\n      color: var(--button-a-text);\n    }\n  }\n\n  .button-b {\n    --background: var(--button-b-background);\n    background: var(--button-b-background);\n    color: var(--button-b-text);\n\n    --background-activated: var(--button-b-over);\n    --background-focused: var(--button-b-over);\n    --background-hover: var(--button-b-over);\n\n    ion-spinner {\n      color: var(--button-b-text);\n    }\n  }\n\n  .color-b {\n    --color: var(--button-b-background);\n    color: var(--button-b-background);\n  }\n\n  .button-a.danger, .button-b.danger {\n    --background: var(--ion-color-danger);\n    background: var(--ion-color-danger);\n    color: #fff;\n    --color: #fff;\n  }\n\n  .button-a.primary, .button-b.primary {\n    --background: var(--ion-color-primary);\n    background: var(--ion-color-primary);\n    color: #fff;\n    --color: #fff;\n  }\n\n  .note-popover .bar, .center-popover .popover-content {\n    background: var(--main-top);\n    color: var(--main-top-text);\n    top: 110px !important;\n  }\n\n\n  .title-row {\n    background: var(--button-b-background);\n    color: var(--button-b-text);\n  }\n\n  //ion-segment {\n  //  --border-color: var(--button-a-background);\n  //  --color: var(--button-a-text);\n  //\n  //  --background-focused: var(--button-a-background);\n  //  --color-focused: var(--button-a-text);\n  //\n  //  --background-checked: #f9f9f9;\n  //  --color-checked: var(--button-a-text);\n  //\n  //  margin: 0;\n  //  background: var(--button-a-background);\n  //\n  //  //--border-color: var(--button-a-background);\n  //  //--color: var(--button-a-background);\n  //  //\n  //  //--background-focused: var(--button-a-background);\n  //  //--color-focused: var(--button-a-text);\n  //  //\n  //  //--background-checked: #f9f9f9;\n  //  //--color-checked: var(--button-a-background);\n  //  //\n  //  //margin: 0;\n  //  //background: #f9f9f9;\n  //\n  //  ion-segment-button {\n  //    min-width: 20px;\n  //    --border-width: 0;\n  //  }\n  //\n  //}\n\n\n  // animation\n\n  .animation {\n    .from-top.hidden {\n      top: -200px;\n    }\n\n    .from-top.show {\n      top: 0;\n    }\n\n    .from-top {\n      -webkit-transition: top 0.5s ease-in-out;\n      -moz-transition: top 0.5s ease-in-out;\n      -ms-transition: top 0.5s ease-in-out;\n      -o-transition: top 0.5s ease-in-out;\n      transition: top 0.5s ease-in-out;\n    }\n\n    .from-bottom.hidden {\n      bottom: -200px;\n    }\n\n    .from-bottom.show {\n      bottom: 0;\n    }\n\n    .from-bottom {\n      -webkit-transition: bottom 0.5s ease-in-out;\n      -moz-transition: bottom 0.5s ease-in-out;\n      -ms-transition: bottom 0.5s ease-in-out;\n      -o-transition: bottom 0.5s ease-in-out;\n      transition: bottom 0.5s ease-in-out;\n    }\n  }\n\n  .no-animation {\n    .animation {\n      .from-top, .from-bottom {\n        -webkit-transition: initial;\n        -moz-transition: initial;\n        -ms-transition: initial;\n        -o-transition: initial;\n        transition: initial;\n      }\n    }\n  }\n\n\n  ion-toast.no-shadow {\n    box-shadow: none;\n    --box-shadow: none;\n\n    .toast-wrapper {\n      box-shadow: none !important;\n    }\n  }\n}\n\n.active-btn {\n  position: absolute;\n  top: 0;\n  z-index: 200;\n  left: 0;\n}\n\nion-menu.app-menu.active-box {\n  display: none;\n}\n\n.app-menu.active-box.active {\n  display: initial;\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
